<template>
  <v-dialog v-model="internalValue" max-width="860" scrollable>
    <v-card>
      <v-card-title class="headline">Términos y consentimiento de datos</v-card-title>

      <v-card-text class="terms-content">
        <p>
          Al postular autorizas a SUNSHINE EXPORT S.A.C. a tratar tus datos personales
          para fines de reclutamiento, evaluación y contacto sobre vacantes laborales.
        </p>

        <p>
          Esta autorización se otorga de forma libre, previa, expresa, inequívoca e
          informada, conforme a la Ley N. 29733 y su reglamento vigente.
        </p>

        <p>
          Tus datos podrán ser usados para validar tu perfil, coordinar entrevistas,
          registrar tus respuestas y mantener trazabilidad del proceso de selección.
        </p>

        <p>
          Puedes ejercer tus derechos ARCO (acceso, rectificación, cancelación y
          oposición) escribiendo a privacidad@sunshineperu.com.
        </p>

        <p>
          Revisa la política completa de privacidad en:
          <a
            href="https://www.sunshineperu.com/privacidad"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.sunshineperu.com/privacidad
          </a>
        </p>
      </v-card-text>

      <v-divider />

      <v-card-actions class="justify-end">
        <v-btn text color="grey darken-1" @click="internalValue = false">
          Cerrar
        </v-btn>
        <v-btn color="primary" @click="acceptTerms">
          He leído y acepto
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TermsConvocatory",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  methods: {
    acceptTerms() {
      this.$emit("accepted");
      this.internalValue = false;
    },
  },
};
</script>

<style scoped>
.terms-content {
  line-height: 1.45;
}
</style>
